// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}
.table-header__left {
  display: flex;
  align-items: center;
  gap: 30px;
}
.table-header__left__search {
  display: flex;
  align-items: center;
}
.table-header__left__search .pui-form-input-field {
  border-radius: 4px 0 0 4px;
  border-right-width: 0;
}
.table-header__left__search__button .pui-button {
  border-radius: 0 4px 4px 0;
}
.table-header__page-size {
  display: flex;
  align-items: center;
  gap: 12px;
}
.table-header__page-size__select {
  width: 80px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
